module.exports = __webpack_public_path__ + "media/images/emblems/Egnach-coat_of_arms-248976c8432e697cb36d37a786bd6dd3.svg";